import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as jwt_decode from 'jwt-decode'
import { map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { UserModel } from '../models/user.model';

import { environment } from '../../environments/environment';
import { UserHelper } from '../helpers/user';
import { CommonHelper } from '../helpers/common';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private userLogin$ = new Subject<UserModel>();
  private language: string = CommonHelper.storeLanguage;
  private url = environment.urlApiRest;
  private apiKey = '';

  token: string;

  //businessman/login

  constructor(private userHelper: UserHelper, private http: HttpClient) { }

  login(user: UserModel) {
    let authData = {
      'email': user.email,
      'password': user.password
    };

    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post(`${this.url}users/login?is_lmp_live=1`, authData, { headers: headers }).pipe(
      map(resp => {
        this.saveToken(resp['response']['token']);
        return resp;
      })
    );
  }
  smsLogin(code: String) {

    let authData = {
      'code': code
    };

    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post(`${this.url}users/account_kit_login?testing=1&is_lmp_live=1`, authData, { headers: headers }).pipe(
      map(resp => {
        this.saveToken(resp['response']['token']);
        return resp;
      })
    );
  }

  facebookLogin(facebookUser) {

    let headers = new HttpHeaders({});

    return this.http.post(`${this.url}users/login/facebook`, facebookUser, { headers: headers }).pipe(
      map(resp => {
        this.saveToken(resp['response']['token']);
        return resp;
      })
    );
  }

  appleLogin(appleUser) {

    let headers = new HttpHeaders({});

    return this.http.post(`${this.url}users/login/apple`, appleUser, { headers: headers }).pipe(
      map(resp => {
        console.log(resp)
        this.saveToken(resp['response']['token']);
        return resp;
      })
    );
  }


  update(user: UserModel) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': localStorage.getItem('token')
    });
    return this.http.post(`${this.url}users/${user.id}?is_lmp_live=1`, user, { headers: headers }).pipe(map(resp => {
      this.saveToken(resp['response']['token']);
      return resp;
    }));
  }

  private saveToken(token: string) {
    console.log('token: ', token);
    this.token = token;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(jwt_decode(localStorage.getItem('token'))));

    // Emitir los nuevos valores para que todos los que dependan se actualicen.
    this.userLogin$.next(new UserModel(jwt_decode(localStorage.getItem('token'))));

    console.log("userlogin emitido");
  }

  getLoginAuthenticate$(): Observable<UserModel> {
    return this.userLogin$.asObservable();
  }


  getToken() {
    return this.token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
  }

  isAuthenticate(): boolean {
    this.getToken();
    return this.token ? true : false;//this.token.length > 2;
  }

  register(user: UserModel) {

    let userData = {
      ...user,
      password_confirm: user.password
    };

    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post(`${this.url}/users/register?is_lmp_live=1`, userData, { headers }).pipe(
      map(resp => {

        if (resp['response']) this.saveToken(resp['response']['token']);
        return resp;
      })
    );
  }

  logout() {
    const user = this.userHelper.getUser();
    this.http.delete(`${this.url}users/logout/${user.id}`).subscribe(() => {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      this.userLogin$.next();
      window.location.href = '/home';
    });
  }

  recoveryPassword(user: UserModel) {

    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post(`${this.url}users/forgot?is_lmp_live=1&lang=${this.language}`, user, { headers: headers }).pipe(map(resp => {
      return resp;
    }));
  }

  geolocation() {

    let userData = {
      "ip": '0.0.0.0'
    }

    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post(`${this.url}user/geolocation`, userData, { headers: headers }).pipe(map((resp) => { return resp; }));
  }

  getIP() {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.get(`https://api.ipify.org?format=json`, { headers: headers }).pipe(map(resp => { return resp['ip']; }));
  }

  video(url, gameId = '') {

    let data = new FormData();
    data.append('src', url);
    return this.http.post(`${this.url}streaming?gameId=${gameId}&isWeb=true&platform=webapp`, data).pipe(map((resp) => { return resp; }));
  }

  getAccessId() {
    this.getToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': this.token,
    });
    return this.http.post(`${this.url}videos/access`, {}, { headers: headers }).pipe(map((resp) => { return resp; }));
  }

  public getProfile(): Observable<any> {
    return this.http.get(this.url + 'users/me').pipe(map<any, any>(resp => {
      this.saveToken(resp.response.token);
      return resp;
    }));
  }

}
